module.exports = __webpack_public_path__ + "img/guangda.1d909f43.png";